import { render, staticRenderFns } from "./DealDetails.vue?vue&type=template&id=152c89f6&"
import script from "./DealDetails.vue?vue&type=script&lang=ts&"
export * from "./DealDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DealDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports